import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'react-jss'
import classNames from 'classnames'

import titleStyles from './title-style'

const Title = props => {
  const classes = titleStyles(props.theme)
  const titleClasses = classNames(
    classes.title,
    props.className,
    props.classType ? classes[props.classType] : null
  )

  return (
    <p className={titleClasses}>{props.children}</p>
  )
}

Title.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  classType: PropTypes.string,
}

export default withTheme(Title)
